import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { api } from '@mmef/shared/api';
import { authReducer } from '@mmef/shared/auth';
import filtersReducer from '@/features/events/filtersSlice';
import promptsReducer from '@/components/promptsSlice';

/**
 * `makeStore` exists so tests can build a fresh, isolated store per case — a module-level
 * singleton leaks cache and auth state between tests.
 */
export function makeStore() {
  const store = configureStore({
    reducer: {
      [api.reducerPath]: api.reducer,
      auth: authReducer,
      filters: filtersReducer,
      prompts: promptsReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware),
  });

  // Refetch on network reconnect / tab focus. Cheap freshness for a list that changes rarely.
  setupListeners(store.dispatch);
  return store;
}

export const store = makeStore();

export type AppStore = ReturnType<typeof makeStore>;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];
